import React from 'react'
import { CustomLinkComponent } from 'msp-components'
import * as S from './PosStart.styles'

type Teaser = {
  imgSrc: string
  text: string
  href: string
}

const Teaser = ({ imgSrc, text, href }: Teaser) => {
  return (
    <CustomLinkComponent href={href} inline className={S.linkWrapper}>
      <img src={imgSrc} className={S.image} alt={text} />
      <div className={S.teaserTextWrapper}>
        <p className={S.teaserText}>{text}</p>
      </div>
    </CustomLinkComponent>
  )
}

export default Teaser
